export class ColaboradorFilterOptions {
    public q = '';
    public codigo = '';
    public nome = '';
    public cpf = '';
    public matricula = '';

    public centroCusto: number[] = [];
    public unidade: number[] = [];
    public departamento: number[] = [];

    public aplicativo = '';
    public situation: string = null;

    public permitirBuscarNome = true;
    public permitirBuscarCPF = true;
    public permitirBuscarNomeLike = true;
    public permitirBuscarCPFLike = true;
    public permitirBuscarVazio = true;
}
